export default {
  hero: {
    title: 'QUIÉNES SOMOS',
    subtitle:
      'Contamos con 20 años en el mercado, somos una consultoría estratégica de Innovación y Transformación Digital. Nuestra especialidad es impulsar los negocios. Integramos la tecnología, las personas y los procesos para mejorar los resultados de nuestros clientes.',
  },
}
